import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { contact, navLinks } from '../data/site';
export function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-200 ease-out border-b ${scrolled || open ? 'bg-forest-950/95 backdrop-blur border-cream-100/10' : 'bg-transparent border-transparent'}`} data-id="element-87" data-mp="qz06pdi1tftd">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 lg:px-10" data-id="element-88" data-mp="2ga0nma1mw1a1">
        <a href="#top" className="flex items-baseline gap-1 whitespace-nowrap" aria-label="Le Bistrot Jeanot — accueil" data-id="element-89" data-mp="2bbpe60f93ssc">
          <span className="font-serif text-2xl tracking-wide text-cream-50" data-id="element-90" data-mp="29lwmv6q8s7ng">Le Bistrot</span>
          <span className="font-script text-3xl leading-none text-ember-400" data-id="element-91" data-mp="2eh28e4fqfkb0">Jeanot</span>
        </a>

        <nav aria-label="Navigation principale" className="hidden md:block" data-id="element-92" data-mp="2jirhheje9nwg">
          <ul className="flex items-center gap-8" data-id="element-93" data-mp="2ofrt04z0jiuy">
            {navLinks.map(link => <li key={link.href} data-id="element-94" data-mp="1qudojd75xhrr">
                <a href={link.href} className="whitespace-nowrap text-sm text-cream-100/80 transition-colors duration-150 hover:text-cream-50" data-id="element-95" data-mp="1qr7xhsez45te">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-3" data-id="element-96" data-mp="25k1p2c7iscef">
          <a href={contact.phoneHref} className="hidden whitespace-nowrap rounded-full bg-cream-100 px-5 py-2.5 text-sm font-medium text-forest-950 transition-colors duration-150 hover:bg-ember-400 sm:inline-flex" data-id="element-97" data-mp="181rw72vgs9bx">
            Réserver une table
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} className="inline-flex h-10 w-10 items-center justify-center rounded-full text-cream-50 md:hidden" aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'} data-id="element-98" data-mp="1013pwr7w6nbl">
            {open ? <XIcon className="h-5 w-5" data-id="element-99" data-mp="h3anrr53ehf9" /> : <MenuIcon className="h-5 w-5" data-id="element-100" data-mp="h42eanju1oyo" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-101" data-mp="w1324fywkzrv">
        {open && <motion.nav id="mobile-nav" aria-label="Navigation mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-cream-100/10 px-6 pb-8 pt-4 md:hidden" data-id="element-102" data-mp="w1uxpqsi2xi5">
            <ul className="flex flex-col gap-4" data-id="element-103" data-mp="29zd90jc31opm">
              {navLinks.map(link => <li key={link.href} data-id="element-104" data-mp="2f00w4tx6xlek">
                  <a href={link.href} onClick={() => setOpen(false)} className="font-serif text-3xl text-cream-50" data-id="element-105" data-mp="2ex50jc8tf8ta">
                    {link.label}
                  </a>
                </li>)}
            </ul>
            <a href={contact.phoneHref} className="mt-8 inline-flex rounded-full bg-cream-100 px-6 py-3 text-sm font-medium text-forest-950" data-id="element-106" data-mp="2sqw9aieq2ony">
              Réserver · {contact.phone}
            </a>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}